/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export const superAppModules = {
  FLIGHT: 'flights',
  SNAP_SEARCH: 'snap',
  SNAP_LISTING: 'snap_deeplink',
  HOTEL_SEARCH: 'hotels',
  HOTEL_BOOKING_DETAILS: 'hotel_booking_detail',
  RIDE: 'ride',
  CHANGE_FLIGHT: 'change_flight',
  OTA_POST_BOOKING: 'ota_postbooking',
  EXPRESS: 'express',
  BIG_REWARDS: 'big_rewards',
  HOTEL_DEEPLINK: 'hotel_deeplink',
  DUTY_FREE: 'travelmall',
  MOVETIX: 'movetix',
} as const;

export type SuperAppModuleKey = keyof typeof superAppModules;

export type SuperAppModulesValue = (typeof superAppModules)[SuperAppModuleKey];
